function Home() {
  return (
    <div>
      <h1>Flow Signup</h1>
      <p>React + TypeScript project initialized successfully!</p>
    </div>
  );
}

export default Home;

